<template>
  <ion-list v-if="resources != null">
    <ion-list-header class="ion-margin-bottom">
      <h3>Exam Result</h3>
    </ion-list-header>
    <ion-list
      v-for="item in resources.data"
      :key="item.id"
      :ref="`items-${item.id}`"
    >
      <ion-item>
        <ion-label
          :router-link="{
            name: 'exam.student-result',
            params: {
              exam: exam_id,
              title: `${item.name} ${exam_name}`,
              exam_type: exam_type,
              standard_id: item.id
            },
          }"
        >
          <h5>Class {{ item.name }}</h5>
        </ion-label>
        <ion-buttons slot="end">
          <ion-button @click="getResult(item)">
            <ion-icon
              :ios="cloudDownloadOutline"
              :md="cloudDownloadOutline"
              size="small"
            ></ion-icon>
            &nbsp; XLS
          </ion-button>
        </ion-buttons>
      </ion-item>
    </ion-list>
  </ion-list>
  <ion-list v-else>
    <ion-list-header>
      <p>No standards found</p>
    </ion-list-header>
  </ion-list>
</template>
<script>
import {
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonButtons,
  IonButton,
  IonIcon,
} from "@ionic/vue";

import { cloudDownloadOutline } from "ionicons/icons";
import base_url from "../../../../apis/base_url";

export default {
  props: {
    resources: {
      type: Object,
      required: true,
    },
    exam_id: {
      type: String,
      required: true,
    },
    exam_name: {
      type: String,
      required: true,
    },
    exam_type: {
      type: String,
      required: true,
    },
  },

  components: {
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonButtons,
    IonButton,
    IonIcon,
  },
  data() {
    return {
      cloudDownloadOutline,
      base_url,
    };
  },
  computed: {
    token() {
      return this.$store.getters["auth/token"];
    },
  },
  methods: {
    getResult(item) {
      const standard_id = item.id;
      const exam_id = this.exam_id;
      const url = `${this.base_url}api/v1/download-result-standard?pat=${this.token}&standard_id=${standard_id}&exam_id=${exam_id}`;
      const new_download_button = document.createElement("a");
      new_download_button.href = url;
      // new_download_button.download = "admit_card.pdf";
      new_download_button.click();
    },
  },
};
</script>